import { GameEntity } from '@okletsplay/core';
import React, { FC, useMemo } from 'react';
import { Accordion } from 'shared/components/Accordion';
import { useFormContext } from 'react-hook-form';
import { MatchFormFields } from 'modules/matches/interfaces/forms';
import { MatchAccordionDescription } from '../../MatchAccordionDescription';
import { DynamicSchemaBlock } from 'shared/components/Form/DynamicSchemaBlock';
import { CheckersChessMatchSettingsForm } from '../CheckersChessMatchSettingsForm';

interface ComponentProps {
  game: GameEntity | undefined;
  onAccordionClick: () => void;
  isExpanded: boolean;
}

export const MatchSetupSettingsForm: FC<ComponentProps> = ({
  onAccordionClick,
  isExpanded,
  game,
}) => {
  const form = useFormContext<MatchFormFields>();
  const {
    formState: { errors },
  } = form;

  const description = useMemo(
    () => (errors.matchSetupSettings ? '?' : ''),
    [errors.matchSetupSettings]
  );

  const properties = game?.matchesConfiguration?.matchSetupSettings?.properties;

  if (!properties) return null;

  return (
    <Accordion
      title="Match Settings"
      description={<MatchAccordionDescription text={description} />}
      onChange={onAccordionClick}
      expanded={isExpanded}
    >
      <CheckersChessMatchSettingsForm />
      <DynamicSchemaBlock
        variant="create"
        properties={properties}
        rootPropertyName="matchSetupSettings"
      />
    </Accordion>
  );
};
